import React, { useState, useContext, useEffect } from "react";
import { Badge, Select, Box, Button, Skeleton, Checkbox, Divider, HStack, Icon, IconButton, Input, InputGroup, InputLeftElement, List, ListItem, Stack, Text, useBreakpointValue, useColorModeValue as mode, VStack, } from "@chakra-ui/react";
import { FiEdit2, FiSearch, FiTrash2, FiPlay, FiRefreshCw, FiPlusSquare, FiFolder, FiPlus, FiLayers, FiBriefcase } from "react-icons/fi";
import { useNavigate  } from "react-router-dom";
import { AppContext } from "../../App";
import { IApiTradeResponse } from "../../models/api/trade/IApiTradeResponse";
import { ApiContext } from "../../contexts/ApiProvider";
import toast from "react-hot-toast";
import { AddTradeDrawer } from "../../components/drawers/trade/AddTradeDrawer";
import { EditTradeDrawer } from "../../components/drawers/trade/EditTradeDrawer";
import { IApiTradeEditRequest } from "../../models/api/trade/IApiTradeEditRequest";
import Helpers from "../../Helpers";
import { AlgoliaTable } from "../../components/AlgoliaTable/AlgoliaTable";

interface ITradesProps {

}

export const Trades: React.FunctionComponent<ITradesProps> = (props: ITradesProps) => {

    const navigate = useNavigate();
    const { me, setAppShellConfig } = useContext(AppContext);
    const { postTrade, patchTrade, deleteTrade } = useContext(ApiContext);

    const addState = useState(false);
    const [add, setAdd] = addState;

    useEffect(() => {
        setAppShellConfig({
            breadcrumbs: [{
                text: `Vorlagen`,
                icon: FiLayers,
            },
            {
                text: `Gewerke`,
                icon: FiBriefcase,
            }],
            rightButton: {
                text: "Erstellen",
                icon: FiPlus,
                ariaLabel: "erstellen",
                variant: "primary",
                onClick: () => {
                    setAdd(true);
                }
            }
        });
    }, [setAppShellConfig, me, navigate, setAdd]);

    return (
        <Stack spacing="4" height="full" direction="column">
            <AlgoliaTable<IApiTradeResponse> 
                indexName="dev_trades"
                getColumns={(columnHelper, setEdit, deleteAction) => [
                    columnHelper.accessor('value', {
                        header: () => 'Bezeichnung',
                        cell: info => info.getValue(),
                    }),
                    columnHelper.display({
                        id: 'actions',
                        cell: info => {
                            const trade = info.row.original;
                            return (
                                <HStack spacing="0" justifyContent="end">
                                    <IconButton
                                        icon={<FiEdit2 fontSize="1.125rem" />}
                                        variant="ghost"
                                        aria-label="Bearbeiten"
                                        onClick={(e) => { 
                                            e.stopPropagation(); 
                                            setEdit(trade);
                                        }}
                                    />
                                    <IconButton
                                        icon={<FiTrash2 fontSize="1.125rem" />}
                                        variant="ghost"
                                        aria-label="Löschen"
                                        onClick={(e) => { 
                                            e.stopPropagation();
                                            deleteAction(trade);
                                        }}
                                    />                           
                                </HStack>
                            );
                        },
                    }),
                ]}
                getCard={(trade, setEdit, deleteAction) => ({
                    key: trade.id,
                    value: trade.id,
                    content: (
                        <HStack spacing="4" justifyContent="space-between">
                            <VStack spacing="2" align="left">
                                <Text fontWeight="medium" fontSize={{ base: "sm", md: "md" }}>
                                    {trade.value}
                                </Text>
                            </VStack>
                            <HStack spacing="4" justifyContent="end">
                                <IconButton
                                    icon={<FiEdit2 fontSize="1.25rem" />}
                                    variant="ghost"
                                    aria-label="Bearbeiten"
                                    onClick={(e) => { 
                                        e.stopPropagation(); 
                                        setEdit(trade);
                                    }}
                                />
                                <IconButton
                                    icon={<FiTrash2 fontSize="1.25rem" />}
                                    variant="ghost"
                                    aria-label="Löschen"
                                    onClick={(e) => { 
                                        e.stopPropagation(); 
                                        deleteAction(trade);
                                    }}
                                />
                            </HStack>
                        </HStack>
                    )
                })}
                deleteAction={(item, deleteItem) => ({
                    title: `Gewerk löschen`,
                    body: `Sind Sie sicher, dass dieses Gewerk gelöscht werden soll?`,
                    onConfirm: () => {
                        var promise = deleteTrade(item.id);
                        toast.promise(promise, {
                            loading: `Gewerk wird gelöscht...`,
                            success: (result) => {
                                deleteItem(result);
                                return `Das Gewerk wurde erfolgreich gelöscht!`;
                            },
                            error: (code) => Helpers.buildToastErrorMessage(code, `Fehler beim Löschen des Gewerks!`)
                        });
                        return promise;
                    }
                })}
                addState={addState}
                getAddDrawer={([state, setState], addItem) => (
                    <AddTradeDrawer 
                        isOpen={state} 
                        onDiscard={() => setState(false)}
                        onSubmit={(data) => {
                            var promise = postTrade(data);
                            toast.promise(promise, {
                                loading: `Gewerk wird erstellt...`,
                                success: (result) => {
                                    setState(false);
                                    addItem(result);
                                    return `Das Gewerk wurde erfolgreich erstellt!`;
                                },
                                error: (code) => Helpers.buildToastErrorMessage(code, `Fehler beim Erstellen des Gewerks!`)
                            });
                            return promise;
                        }}
                    />
                )}
                getEditDrawer={([state, setState], replaceItem) => (
                    <EditTradeDrawer 
                        defaultValue={state as IApiTradeEditRequest} 
                        onDiscard={() => setState(undefined)} 
                        onSubmit={(data) => {
                            var promise = patchTrade(state!.id, data);
                            toast.promise(promise, {
                                loading: `Gewerk wird aktualisiert...`,
                                success: (result) => {
                                    setState(undefined);
                                    replaceItem(result)
                                    return `Das Gewerk wurde erfolgreich aktualisiert!`;
                                },
                                error: (code) => Helpers.buildToastErrorMessage(code, `Fehler beim Aktualisieren des Gewerks!`)
                            });
                            return promise;
                        }}
                    />
                )}
            />
        </Stack>
    );

}